import React from 'react';
import classNames from 'classnames';
import { OverlayView } from 'react-google-maps';

import { SearchMapInfoCard } from '../../components';
import { CustomOverlayView } from './components/CustomOverlayView';
import { getPixelPositionOffset } from './SearchMap.helpers.js';
import { ConditionalWrapper } from '../../util/common';
import { ensureListing } from '../../util/data';

import css from './InfoCardComponent.css';

const InfoCardComponent = ({
    infoCardOpen,
    onListingInfoCardClicked,
    createURLToListing,
    mapComponentRefreshToken,
    isMobile,
}) => {
    const listingsArray = Array.isArray(infoCardOpen) ? infoCardOpen : [infoCardOpen];
    const firstListing = ensureListing(listingsArray[0]);
    const geolocation = firstListing.attributes.geolocation;
    const latLngLiteral = { lat: geolocation.lat, lng: geolocation.lng };

    return (
        <ConditionalWrapper
            condition={!isMobile}
            wrapper={children => (
                <CustomOverlayView
                    key={listingsArray[0].id.uuid}
                    position={latLngLiteral}
                    mapPaneName={OverlayView.FLOAT_PANE}
                    getPixelPositionOffset={getPixelPositionOffset}
                    styles={{ zIndex: 1 }}
                >
                    {children}
                </CustomOverlayView>
            )}
        >
            <SearchMapInfoCard
                mapComponentRefreshToken={mapComponentRefreshToken}
                rootClassName={classNames({
                    [css.searchMapInfoCardMob]: !!isMobile,
                })}
                listings={listingsArray}
                onListingInfoCardClicked={onListingInfoCardClicked}
                createURLToListing={createURLToListing}
                coordinateAdjustmentAllowed={!isMobile}
            />
        </ConditionalWrapper>
    );
};

export default InfoCardComponent;
